__turbopack_context__.v({
  "chart": "UspCharts-module-scss-module__eNaGVG__chart",
  "chart-wrapper": "UspCharts-module-scss-module__eNaGVG__chart-wrapper",
  "dip": "UspCharts-module-scss-module__eNaGVG__dip",
  "peak": "UspCharts-module-scss-module__eNaGVG__peak",
  "price": "UspCharts-module-scss-module__eNaGVG__price",
  "time": "UspCharts-module-scss-module__eNaGVG__time",
});
